module.exports = __webpack_public_path__ + "static/media/tab-8bit-creamy.fee0e9a8.png";